import { XR_LOCOMOTION_DEAD_ZONE } from '../_data/spaceCanvas.js';
export function applyDeadZone(value) {
    if (Math.abs(value) < XR_LOCOMOTION_DEAD_ZONE)
        return 0;
    return Math.sign(value) * (Math.min(1, Math.abs(value)) - XR_LOCOMOTION_DEAD_ZONE)
        / (1 - XR_LOCOMOTION_DEAD_ZONE);
}
export function isPressed(button) {
    return button?.state === 'pressed' || (button?.button ?? 0) > 0.5;
}
export function resolveCameraFar(cameraPose) {
    const distanceToTarget = Math.hypot(cameraPose.position[0] - cameraPose.target[0], cameraPose.position[1] - cameraPose.target[1], cameraPose.position[2] - cameraPose.target[2]);
    return Math.max(2000, distanceToTarget * 4);
}
